import "react-loading-skeleton/dist/skeleton.css";

import React from "react";
import Skeleton from "react-loading-skeleton";

import loaderIcon from "../../assets/gifs/Animation - 1702974649097.gif";

const Loader = () => (
  <div className="">
    <img src={loaderIcon} alt="loader" width={30} height={30} className="animate-spin" />
  </div>
);

const TableLoader = () => {
  const array = new Array(20).fill(null).map((u, i) => i);

  return (
    <>
      {array.map((item, index) => {
        return (
          <tr id="list" key={index}>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
            <td className="text-center  ">
              <Skeleton />
            </td>
          </tr>
        );
      })}
    </>
  );
};

export default TableLoader;
